import React from 'react';
import { Hero } from './components/Hero';
import { BrokenSignals } from './components/BrokenSignals';
import { Protocol } from './components/Protocol';
import { CoreModules } from './components/CoreModules';
import { DeploymentTiers } from './components/DeploymentTiers';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-[#050508]" data-id="element-0">
      <Hero data-id="element-1" />
      <BrokenSignals data-id="element-2" />
      <Protocol data-id="element-3" />
      <CoreModules data-id="element-4" />
      <DeploymentTiers data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}